import { createHash } from "crypto"

export function hashify(str: string) {
    return createHash("sha1").update(str).digest("hex")
}
